import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { ASSISTANT_DESC } from "@/lib/assistant";
import { BrandLabel } from "@/components/BrandLabel";

function Brand({ compact = false }) {
  return (
    <div className={`flex flex-col items-center text-center ${compact ? "mb-5" : ""}`}>
      <img src="/rb-logo.webp" alt="RB Studio"
        className={compact ? "w-20 h-20 object-contain mb-3" : "w-36 h-36 object-contain mb-5"} />
      <BrandLabel className={`font-serif text-[#1A2B4A] ${compact ? "text-xl w-36" : "text-5xl w-64"}`} />
      {!compact && (
        <>
          <div className="w-64 h-64 mt-6 rounded-[26px] overflow-hidden bg-[#F4E8CA] shadow-[0_8px_28px_rgba(15,26,46,0.08)] flex items-center justify-center">
            <img src="/ill-login.jpg" alt="Consulenza RB Studio" data-testid="ill-login"
              className="w-full h-full object-contain" />
          </div>
          <p className="text-sm text-[#4a5568] max-w-xs mt-4 leading-relaxed">{ASSISTANT_DESC}</p>
        </>
      )}
    </div>
  );
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch {
      toast.error("Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#f9f8f5]">
      {/* Left — brand + nome assistente */}
      <div className="hidden lg:flex items-center justify-center bg-gradient-to-b from-[#faf6ec] via-white to-white p-10">
        <Brand />
      </div>

      {/* Right — login form */}
      <div className="flex items-center justify-center p-5 bg-[#f9f8f5]">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden"><Brand compact /></div>

          <h1 className="text-2xl font-semibold tracking-tight text-[#1A2B4A] mb-5">Welcome</h1>

          <label className="text-[10px] font-medium uppercase tracking-[0.12em] text-[#8a93a6]">Email</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            autoComplete="username" placeholder="nome@dominio.com"
            className="w-full mt-1 mb-5 px-4 py-2.5 bg-white border border-[#1A2B4A]/20 rounded-md focus:border-[#C9A84C] focus:ring-2 focus:ring-[#C9A84C]/30 focus:outline-none transition-all" />

          <label className="text-[10px] font-medium uppercase tracking-[0.12em] text-[#8a93a6]">Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            className="w-full mt-1 mb-5 px-4 py-2.5 bg-white border border-[#1A2B4A]/20 rounded-md focus:border-[#C9A84C] focus:ring-2 focus:ring-[#C9A84C]/30 focus:outline-none transition-all" />

          <button data-testid="login-submit" disabled={loading}
            className="w-full bg-[#1A2B4A] text-white py-3 rounded-full font-semibold hover:bg-[#22345c] active:scale-[0.98] transition-all flex items-center justify-center gap-2">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Accedi
          </button>
        </form>
      </div>
    </div>
  );
}
